<div class="lob-model-view">
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font">
      <div class="app-stk-header">
        <span class="stk-c-header stk-container-header">
          <img class="stkh-img" src="../../../../assets/images/lob_maintenance.png" />
          <span class="stk-title">
            <span class="stk-header-title">Organization Maintenance</span>
          </span>
        </span>
      </div>

      <div class="uitk-c-card__content">
        <div class="uitk-l-grid__row">
          <div class="uitk-l-grid__col--12">
            <div class="uitk-c-card">
              <div class="uitk_new_header">
                <div class="uitk-l-grid__col--12 stk-container-tabl-header">
                  <div class="stk-header-action">
                    @if (dataSourceDetails && dataSourceDetails.data.length) {
                    <div class="table-search-org">
                      <mat-form-field class="data-filter" appearance="outline">
                        <input
                          [(ngModel)]="searchField"
                          matInput
                          type="text"
                          class="capability-search"
                          placeholder="Search Organization"
                          (keyup)="searchDataSet($event)"
                        />
                        <img src="../../../../assets/images/searchicon.png" class="org-view-search-img" />
                      </mat-form-field>
                    </div>
                    } @if (TABLE_CONFIG.edit) {
                    <button
                      class="stk-action-add add-margin m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button"
                      (click)="AddNewEntry()"
                    >
                      Add
                    </button>
                    } @if (dataSourceDetails && dataSourceDetails.data.length) {
                    <div (click)="exportToExcel()" class="export-link">
                      <span
                        title="Click to Download"
                        class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
                      ></span>
                    </div>
                    }
                  </div>
                </div>
              </div>
              <div class="uitk-c-card__content">
                <div class="stk-table-container">
                  @if (showLoader) {
                  <div class="stk-table-loader">
                    <app-loader> </app-loader>
                  </div>
                  } @if (!showLoader) {
                  <app-maintenance-table-v4
                    [TABLE_CONFIG]="TABLE_CONFIG"
                    [COLUMNS]="TABLE_COLUMNS"
                    [SORT_CONFIG]="sortConfig"
                    [dataSource]="dataSourceDetails"
                    [SCHEMA]="DATA_SCHEMA"
                    (paginationClickEvent)="tablePaginationEvent($event)"
                    (saveEvent)="saveEvent($event)"
                    (checkBoxEvent)="checkBoxEvent($event)"
                    [pageSize]="TABLE_CONFIG.pageSize"
                    (removeRecordEvent)="deleteOrganization($event)"
                    [pageIndex]="TABLE_CONFIG.pageIndex"
                    (cancelEvent)="cancelEvent()"
                  >
                  </app-maintenance-table-v4>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
